export default __webpack_public_path__ + "static/media/instrument_delight.c9d0839c.png";